import { useContext, useEffect, useState } from "react";
import {
  getFunctionalities,
  createFunctionalities,
  updateFunctionalities,
  deleteFunctionalities,
  reactiveFunctionalities,
} from "../services/console/adminfunctionalities";
import { AppContext } from "../context";

type UseType = "DATA" | "ACTIONS";
export type ActionType = "CREATE" | "UPDATE" | "DELETE" | "REACTIVE";

const handleFunctionalitiesFunction = (action: ActionType, t: Function) => {
  switch (action) {
    case "CREATE":
      return {
        actionFn: createFunctionalities,
        fnMsg: t("Functionalities.functionalitiesApiCreateLabel"),
      };
    case "UPDATE":
      return {
        actionFn: updateFunctionalities,
        fnMsg: t("Functionalities.functionalitiesApiUpdateLabel"),
      };
    case "DELETE":
      return {
        actionFn: deleteFunctionalities,
        fnMsg: t("Functionalities.functionalitiesApiDeleteLabel"),
      };
    case "REACTIVE":
        return {
          actionFn: reactiveFunctionalities,
          fnMsg: t("Functionalities.functionalitiesApiReactiveLabel"),
      };
    default:
      return {
        actionFn: () => {},
        fnMsg: "",
      };
  }
};

export const useFunctionalities = (type: UseType) => {
  const { t, toast, setAppState } = useContext(AppContext);
  const [data, setData] = useState<any | null>(null);
  const [reload, setReload] = useState<number>(0);

  const reloadFn = () => {
    setData(null);
    setReload((prev) => prev + 1);
  };

  const functionalitiesAction = async (action: ActionType, data: any) => {
    const { actionFn, fnMsg } = handleFunctionalitiesFunction(action, t);
    setAppState((prev) => ({
      ...prev,
      isLoading: true,
    }));
    const actionStatus = await Promise.resolve(actionFn(data))
      .then((response) => {
        toast.current.replace({
          severity: "success",
          summary: "",
          detail: `${fnMsg.replace('{name}', data?.key)}`,
          life: 3000,
        });
        return "SUCCESS";
      })
      .catch((error) => {
        toast.current.replace({
          severity: "error",
          summary: "",
          detail: error?.response?.data?.header?.errorMsg ?? t('ConsoleTranslations.generalErrorApiMessage'),
          life: 3000,
        });
        return "ERROR";
      });
    setAppState((prev) => ({
      ...prev,
      isLoading: false,
    }));
    return actionStatus;
  };

  useEffect(() => {
    if (type === "DATA") {
      (async function () {
        await Promise.resolve(getFunctionalities())
          .then((response) => {
            setData(response?.data);
          })
          .catch((error) => {
            toast.current.replace({
              severity: "error",
              summary: "",
              detail: error?.response?.header?.errorMsg ?? t('ConsoleTranslations.generalErrorApiMessage'),
              life: 3000,
            });
          });
      })();
    }
  }, [toast, reload, type]);

  return {
    data,
    functionalitiesAction,
    reloadFn,
  };
};
